import { BasicProps } from "../../../common/components/ComponentsInterface";
import { LHero } from "../../../common/components/LHero";
import InternetConnectionModal from "./InternetConnectionModal";

export const AssessmentShell = ({ ...props }: AssessmentShellProps): JSX.Element => {
    return (
        <LHero
            centered
            contentCentered
            size="fullheight"
            includeUnauthenticatedMenu={!props.excludeUnauthenticatedMenu}
            navBarTitle={props.navBarTitle}
            showMic
            micVolume={props.micVolume}
            micIsRecording={props.micIsRecording}
        >
            <InternetConnectionModal />
            {props.children}
        </LHero>
    );
};

interface AssessmentShellProps extends BasicProps {
    navBarTitle?: string;
    micVolume?: number;
    micIsRecording?: boolean;
    excludeUnauthenticatedMenu?: boolean;
}
